// Import model
import { CreateObjectTaskRequest } from '../models/CreateObjectTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateObjectTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateObjectTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateObjectTaskRequest instance
   */
  static deserialize(json: string): CreateObjectTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateObjectTaskRequest instance
   */
  static fromObject(obj: any): CreateObjectTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateObjectTaskRequest');
    }


    const instance: CreateObjectTaskRequest = {
      assignedUserId: obj['assignedUserId'] as string | undefined,
      dueDate: obj['dueDate'] as string | undefined,
      priority: obj['priority'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateObjectTaskRequest instances
   */
  static deserializeArray(json: string): CreateObjectTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateObjectTaskRequest instance to a JSON string
   */
  static serialize(instance: CreateObjectTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateObjectTaskRequest instance to a plain object
   */
  static toObject(instance: CreateObjectTaskRequest): any {
    return {
      'assignedUserId': instance.assignedUserId,
      'dueDate': instance.dueDate,
      'priority': instance.priority,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
      'content': instance.content,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'entityId': instance.entityId,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
    };
  }

  /**
   * Serializes an array of CreateObjectTaskRequest instances to a JSON string
   */
  static serializeArray(instances: CreateObjectTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
